<span>
  {{ tag()?.name ?? tag() }}
</span>
